export default class ExtranetStudyRequestsIndex {
  constructor() {
    //this.bindEvents();
    this.initDatatable();
  }

  initDatatable() {
    let self = this;
    
    this.table = $("#sr-datatable").DataTable({
      "responsive": true,
      "searching": true,
      dom: 'rtp',
      "columnDefs": [{
        "targets": 0,
        "orderable": true,
        "visible": false
      }, {
        "targets": -1,
        "orderable": false
      }],
      "order": [[0, "desc"], [2, "desc"]],
      "language": {
        url: '/data-tables/locales/' + I18n.locale + '.json',
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right>"
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      drawCallback:function(){
        $(".dataTables_paginate > .pagination").addClass("pagination-rounded")
      }
    });

    let $search = $('#customSearch');
    
    if ($search.length !== 0) {
      $search.off('keyup').on('keyup', function() {
        self.table.search($(this).val()).draw();
      });
    }
  }
  
  onDataChanged(data) {
  }

  onDestroy() {
    this.table.destroy();
  }
}